<template lang="html">
  <div id="parentx">
      <vs-sidebar :vs-reduce="reducex" :vs-active.sync="monitorarMenu" class="fs-sidebar" :vs-static="staticMenu">
        <img src="../assets/logofarsoft.png" class="fs-logo">

        <div v-if="usuario.nome" style="padding-top: 10px; padding-left: 5px; padding-right: 5px; margin-left: 0px; font-size: 11px; background-color: rgba(var(--primary),1); color: white; min-height: 50px;">
          <p style="text-align: center">{{ usuario.nome }}</p>
          <p style="text-align: center">{{ usuario.email }}</p>
          <!--<vs-avatar style="position: fixed; top: 92px; width: 40px; height: 40px; float: left; margin-top: 0px;" src="https://avatars2.githubusercontent.com/u/31676496?s=460&v=4"/>-->

           <vs-button style="position: fixed; margin: -65px 0px 0px 220px;" vs-color="danger" vs-type="gradient" @click="chamaLogout()">Sair</vs-button>
           <!-- <button style="position: fixed; margin: -60px 0px 0px 190px;" class="button is-warning" @click="logout()">
           <b-icon
              pack="fas"
              icon="lock">
          </b-icon>
          <span>Sair</span>
          </button> -->
        </div>

        <div v-if="!usuario.nome" style="padding-top: 2px; padding-left: 5px; padding-right: 5px; margin: 0px; font-size: 11px; background-color: rgba(var(--primary),1); color: white; min-height: 50px;">
           <!-- <vs-button vs-type="gradient" @click="cardModalLogin()">Logar-se</vs-button> -->
           <button style="margin: 5px 0px 0px 70px;" class="button is-danger" @click="cardModalLogin()">
           <b-icon
              pack="fas"
              icon="lock"
              custom-class="fa-spin">
          </b-icon>
          <span>LOGAR-SE</span>
          </button>
        </div>

      <span v-if="usuario.nome" v-for='menu in menus' :key="menu.id">

        <vs-sidebar-group :vs-icon-reduce="menu.icon" :vs-label="menu.name" v-if="menu.route === ''">

          <vs-sidebar-item v-for='submenu in menu.submenu' :key="submenu.id" @click="chamarRota(submenu.route, submenu.id, submenu.name)" :vs-icon="submenu.icon"
          :vs-active="actives==submenu.id">
            {{submenu.name}}
          </vs-sidebar-item>

        </vs-sidebar-group>

        <!-- Menus Soltos Sem Submenu -->
        <vs-sidebar-item @click="chamarRota(menu.route, menu.id, menu.name)" :vs-icon="menu.icon"
        :vs-active="actives==menu.id"
        v-if="menu.route !== ''">
          {{menu.name}}
        </vs-sidebar-item>

      </span>

    </vs-sidebar>
  </div>
</template>

<script>
import menuMixIn from '../dados/menu'
import { mapState, mapActions } from 'vuex'

// Componentes Próprios
import ModalFormLogin from '@/components/ModalFormLogin.vue'

export default {
  mixins: [
    menuMixIn // Para puxar o array de menus
  ],
  props: ['activeMenu', 'staticMenu'],
  // Abaixo converti em ES6
  // data () {
  //   return {
  //   }
  // },
  data: () => ({
    actives: 2,
    reducex: false
  }),
  methods: {
    ...mapActions('login', [
      'login',
      'logout'
    ]),
    cardModalLogin () {
      this.$modal.open({
        parent: this,
        component: ModalFormLogin,
        hasModalCard: true
      })
    },
    chamaSair () {
      this.logout().then(res => {
        this.$router.push('logout')
        window.location.href = 'https://www.fortkol.com.br'
      })
    },
    chamaLogout () {
      this.logout().then(res => {
        this.$router.push('logout')
      })
    },
    verificaOpcoesSemRota (name) {
      if (name === 'Logout') {
        this.chamaLogout()
      } else if (name === 'Sair') {
        this.chamaSair()
      } else {
        return false
      }
    },
    chamarRota (rota, opcao, name) {
      if (this.verificaOpcoesSemRota(name)) {
        return false
      } else {
        this.actives = opcao
        this.$emit('ocultarMenu', false) // Oculta o Menu depois de selecionado
        this.$router.push(rota)
        console.log('outra rota')
      }
    }
  },
  watch: {
    staticMenu: function (val) {
      this.$emit('monitorarSwitch', val)
    }
  },
  computed: {
    ...mapState('login', [
      'logged',
      'usuario'
    ]),
    monitorarMenu: {
      get: function () {
        return this.activeMenu
      },
      set: function (val) {
        this.$emit('ocultarMenu', val)
      }
    },
    monitorarSwitch: {
      get: function () {
        return this.staticMenu
      },
      set: function (val) {
        this.$emit('monitorarSwitch', val)
      }
    }

  }
}
</script>

<style lang="scss">
.fs-logo {
  width: 130px;
  margin-left: 65px;
  margin-bottom: 20px;
  top: 0;
}
.fs-sidebar {
  font-family: 'ubuntu', Helvetica, Arial, sans-serif;
  margin-top: 45px;
  margin-block-end: 20px;
}
// .con-example-sidebar {
//   height: 500px;
// }
</style>
